import React from 'react';
import { Form, Card } from 'react-bootstrap';
import ModeComponent from '../../ModeComponent';

export default class SendMessage extends ModeComponent {
  // properties set on each mount
  clockType = 'mechanics';
  defaultFocus = 'causeInput';
  mode = 'SM';

  schema = {
    causeInput: {
      errorText: 'Required field',
      label: 'Message',
      required: true,
    },
  };

  state = {
    causeInput: {
      value: '',
      validationState: null,
    },
  };
  // end properties reset on each mount

  render() {
    return (
      <Card className="success">
        <Card.Header>
          <Card.Title>Action Details</Card.Title>
        </Card.Header>
        <Card.Body>
          <Form
            onSubmit={e => {
              e.preventDefault();
            }}
          >
            {this.validatedTextInput('causeInput')}
          </Form>
        </Card.Body>
      </Card>
    );
  }
}
